
define('text!_crumb.html',[],function () { return '<span class="content" ng-class="{ show: model != base }">\n  <label ng-transclude></label>\n  <a ng-click="clear()" class="clear">&times;</a>\n</span>';});

